import { takeEvery, put, all, call } from 'redux-saga/effects';
import * as types from './userActionTypes';
import * as actions from './userActions';
import * as alert from '../alert/alertActions';
import * as endpoints from '../../services/endpoints';
import Swal from 'sweetalert2';

function* loginSaga({ creds }) {
  try {
    const loginData = {
      Username: creds.data['username'],
      Password: creds.data['password']
    };

    const { data } = yield call(endpoints.login, loginData);
    
    console.log('Login response:', data);
    console.log('Backend Username:', data.Username);
    console.log('Backend FullName:', data.FullName);
    console.log('Backend SessionUserId:', data.SessionUserId);

    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.loginData(data));
      
      yield put(
        alert.setAlertAction({
          title: 'Success!',
          text: data.Result.ErrorDescription || 'Login successful',
          variant: 'success',
        }),
      );

      const userData = {
        sessionUserId: data.SessionUserId,
        username: data.Username || creds.data['username'],
        userStatus: data.UserStatus,
        jwt: data.JWT
      };

      console.log('Saving to localStorage:', userData);

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('token', data.JWT);
      localStorage.setItem('sessionUserId', data.SessionUserId);

      console.log('Saved user data:', localStorage.getItem('user'));
      console.log('Saved sessionUserId:', localStorage.getItem('sessionUserId'));

      if (creds.navigate) {
        creds.navigate('/home', { replace: true });
      }

    } else {
      const errorMessage = data.Result?.ErrorDescription || 'Login failed';
      yield put(
        alert.setAlertAction({
          title: 'Error!',
          text: errorMessage,
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      yield put(actions.loginError(errorMessage));
    }

  } catch (e) {
    console.error('Login error:', e);

    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.Result?.ErrorDescription ||
         e?.response?.data?.message || 'An error occurred during login',
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.loginError(e));
  }
}

function* forgotPasswordSaga({ creds }) {
  try {
    var formData = new FormData();
    formData.append('email', creds['email']);

    const { data } = yield call(endpoints.forgotPassword, formData);

    yield put(actions.forgotPasswordData(data));

    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
        outTimeMS: 8000,
      }),
    );
  } catch (e) {
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.forgotPasswordError(e));
  }
}

function* resetPasswordSaga({ creds }) {
  try {
    const body = { 
      token: creds['resetToken'], 
      new_password: creds['password'] 
    };

    const { data } = yield call(endpoints.resetPassword, body);
    yield put(actions.resetPasswordData(data));

    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
    
    setTimeout(() => {
      if (creds.navigate) {
        creds.navigate('/login');
      } else {
        window.location.href = '/login';
      }
    }, 2000);
  } catch (e) {
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.resetPasswordError(e));
  }
}

function* activationSaga({ creds }) {
  try {
    const body = { 
      token: creds['activationToken'], 
      activation_code: creds['activationCode'] 
    };
    
    const { data } = yield call(endpoints.activation, body);
    yield put(actions.activationData(data));

    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
    
    yield put(actions.accountVerifiedAction(true));
    
    setTimeout(() => {
      if (creds.navigate) {
        creds.navigate('/home');
      } else {
        window.location.href = '/home';
      }
    }, 3000);
  } catch (e) {
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.activationError(e));
  }
}

export function* logoutSaga() {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('sessionUserId');
  
  const checkUser = localStorage.getItem('user');
  console.log('User after logout:', checkUser);
  
  yield put(actions.logoutData());
}

function* signUpSaga({ creds }) {
  try {
    var formData = new FormData();
    formData.append('username', creds.data['username']);
    formData.append('password', creds.data['password']);
    formData.append('email', creds.data['email']);

    const { data } = yield call(endpoints.signUp, formData);
    yield put(actions.signUpData(data));

    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: data.message,
        variant: 'success',
      }),
    );
    
    setTimeout(() => {
      if (creds.navigate) {
        creds.navigate('/login');
      } else {
        window.location.href = '/login';
      }
    }, 3000);
  } catch (e) {
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.signUpError(e));
  }
}

function* getAccountDetailsSaga({ creds }) {
  try {
    const { data } = yield call(endpoints.getAccountDetails);
    yield put(actions.accountDetailsDataAction(data));
  } catch (e) {
    yield put(actions.accountDetailsErrorAction(e));
  }
}

function* resendVerificationEmail({ payload }) {
  try {
    const { data } = yield call(endpoints.resendVerificationEmail);
    yield put(actions.resendVerificationEmailDataAction(data));

    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: data.message,
    });
  } catch (e) {
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.message,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.resendVerificationEmailErrorAction(e));
  }
}

function* checkUserToken({ payload }) {
  try {
    const { data } = yield call(endpoints.checkUserToken);
    yield put(actions.checkUserTokenDataAction(data));
  } catch (e) {
    if (e) {
      yield call(logoutSaga);
      yield put(
        alert.setAlertAction({
          title: 'Session Expired!',
          text: e?.response?.data?.message || 'Your session has expired',
          variant: 'danger',
          outTimeMS: 6000,
        }),
      );
      
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
    yield put(actions.checkUserTokenErrorAction(e));
  }
}

export function* getUserFromLocalStorage() {
  try {
    const userData = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    const sessionUserId = localStorage.getItem('sessionUserId');
    
    if (userData && token) {
      const parsedUserData = JSON.parse(userData);
      return {
        user: parsedUserData,
        token: token,
        sessionUserId: sessionUserId,
        username: parsedUserData.username,
        fullName: parsedUserData.fullName,
        userStatus: parsedUserData.userStatus
      };
    }
    return null;
  } catch (e) {
    console.error('Error getting user from localStorage:', e);
    return null;
  }
}

export function* isUserAuthenticated() {
  const userData = yield call(getUserFromLocalStorage);
  return userData !== null && userData.token !== null;
}

export function* getCurrentUser() {
  const userData = yield call(getUserFromLocalStorage);
  if (userData) {
    return {
      sessionUserId: userData.sessionUserId,
      username: userData.username,
      fullName: userData.fullName,
      userStatus: userData.userStatus,
      jwt: userData.token
    };
  }
  return null;
}

// Watcher functions
function* watchLoginUser() {
  yield takeEvery(types.LOGIN_REQUEST, loginSaga);
}

function* watchLogoutUser() {
  yield takeEvery(types.LOGOUT_REQUEST, logoutSaga);
}

function* watchSignUpUser() {
  yield takeEvery(types.SIGN_UP_REQUEST, signUpSaga);
}

function* watchForgotPassword() {
  yield takeEvery(types.FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
}

function* watchResetPassword() {
  yield takeEvery(types.RESET_PASSWORD_REQUEST, resetPasswordSaga);
}

function* watchActivation() {
  yield takeEvery(types.ACTIVATION_REQUEST, activationSaga);
}

function* watchAccountDetails() {
  yield takeEvery(types.ACCOUNT_DETAILS_REQUEST, getAccountDetailsSaga);
}

function* watchResendVerificationEmail() {
  yield takeEvery(types.RESEND_VERIFICATION_EMAIL_REQUEST, resendVerificationEmail);
}

function* watchCheckUserToken() {
  yield takeEvery(types.CHECK_USER_TOKEN_REQUEST, checkUserToken);
}

export function* userSaga() {
  yield all([
    watchLoginUser(),
    watchLogoutUser(),
    watchSignUpUser(),
    watchForgotPassword(),
    watchResetPassword(),
    watchActivation(),
    watchAccountDetails(),
    watchResendVerificationEmail(),
    watchCheckUserToken()
  ]);
}